// extracted by mini-css-extract-plugin
module.exports = {"root":"sticky-card_root__oq9_T","open":"sticky-card_open__OwUpN","viewButton":"sticky-card_viewButton__9e8AS"};